module.exports = __webpack_public_path__ + "img/Vibration.d78a4d0e.png";